import { createContext, useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api, { setTenantId } from '../services/api';
import Loading from '../components/Loading';
import { ShieldAlert, Home } from 'lucide-react';

const TenantContext = createContext(null);

const renderStaticSite = (siteData) => {
    document.title = siteData.meta_title || siteData.name;
    
    let htmlContent = siteData.html_content;
    if (siteData.logo_url) {
        // Swap out placeholder logo image src with uploaded logo_url
        htmlContent = htmlContent.replace(/<img([^>]*?)alt="Restaurant Logo"([^>]*?)src="([^"]*?)"/gi, (match, p1, p2) => {
            return `<img${p1}alt="Restaurant Logo"${p2}src="${siteData.logo_url}"`;
        });
        htmlContent = htmlContent.replace(/<img([^>]*?)src="([^"]*?)"([^>]*?)alt="Restaurant Logo"/gi, (match, p1, p2, p3) => {
            return `<img${p1}src="${siteData.logo_url}"${p3}alt="Restaurant Logo"`;
        });
    }

    document.open();
    document.write(`
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>${siteData.meta_title || siteData.name}</title>
            <meta name="description" content="${siteData.meta_description || ''}">
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
            <script src="https://cdn.tailwindcss.com"></script>
            <style>
                html, body {
                    margin: 0 !important;
                    padding: 0 !important;
                    width: 100% !important;
                    box-sizing: border-box !important;
                    overflow-x: clip;
                }
                /* Force ALL structural elements to be full-width containers regardless of nesting */
                header, section, footer {
                    max-width: 100% !important;
                    width: 100% !important;
                    margin-left: 0 !important;
                    margin-right: 0 !important;
                }
                header {
                    position: sticky !important;
                    top: 0 !important;
                    z-index: 9999 !important;
                }
                /* Stretch inner container divs of headers/footers (where background colors are applied) */
                header > div, footer > div {
                    max-width: 100% !important;
                    width: 100% !important;
                    margin-left: 0 !important;
                    margin-right: 0 !important;
                }
                ${siteData.css_content || ''}
            </style>
            ${siteData.favicon_url ? '<link rel="icon" href="' + siteData.favicon_url + '">' : ''}
        </head>
        <body>
            ${htmlContent}
            <script>
                (function() {
                    function getThemeColor() {
                        try {
                            var els = document.querySelectorAll('a[href="#menu"], form button[type="submit"], form input[type="submit"], .btn-primary');
                            for (var i = 0; i < els.length; i++) {
                                var s = window.getComputedStyle(els[i]);
                                var bg = s.backgroundColor;
                                if (bg && bg !== "transparent" && bg !== "rgba(0, 0, 0, 0)" && bg !== "rgb(255, 255, 255)") {
                                    return bg;
                                }
                            }
                        } catch(e) {}
                        return "#f97316";
                    }

                    function showModal(title, msg) {
                        var old = document.getElementById("site-modal-overlay");
                        if (old) old.remove();

                        var themeBg = getThemeColor();

                        var overlay = document.createElement("div");
                        overlay.id = "site-modal-overlay";
                        overlay.setAttribute("style", "position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(15,23,42,0.6);backdrop-filter:blur(8px);opacity:0;transition:opacity 0.25s ease-out;");

                        var card = document.createElement("div");
                        card.setAttribute("style", "background:#fff;border-radius:20px;max-width:420px;width:100%;padding:32px 24px;text-align:center;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);transform:scale(0.9);transition:transform 0.25s cubic-bezier(0.16,1,0.3,1);border:1px solid #f1f5f9;");

                        var icon = document.createElement("div");
                        icon.setAttribute("style", "width:56px;height:56px;border-radius:50%;background:#ecfdf5;color:#10b981;display:flex;align-items:center;justify-content:center;font-size:24px;font-weight:bold;margin:0 auto 20px auto;");
                        icon.textContent = String.fromCharCode(10003);

                        var h3 = document.createElement("h3");
                        h3.setAttribute("style", "margin:0 0 10px 0;color:#0f172a;font-size:1.35rem;font-weight:700;");
                        h3.textContent = title;

                        var p = document.createElement("p");
                        p.setAttribute("style", "margin:0 0 24px 0;color:#64748b;font-size:0.95rem;line-height:1.5;");
                        p.textContent = msg;

                        var btn = document.createElement("button");
                        btn.setAttribute("style", "width:100%;padding:14px 24px;background-color:" + themeBg + ";color:#fff;border:none;border-radius:8px;font-weight:600;font-size:1rem;cursor:pointer;transition:all 0.2s ease;box-shadow:0 4px 14px rgba(0,0,0,0.15);");
                        btn.textContent = "Continue";

                        card.appendChild(icon);
                        card.appendChild(h3);
                        card.appendChild(p);
                        card.appendChild(btn);
                        overlay.appendChild(card);
                        document.body.appendChild(overlay);

                        requestAnimationFrame(function() {
                            overlay.style.opacity = "1";
                            card.style.transform = "scale(1)";
                        });

                        function closeIt() {
                            overlay.style.opacity = "0";
                            card.style.transform = "scale(0.9)";
                            setTimeout(function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 250);
                        }

                        btn.onclick = closeIt;
                        overlay.onclick = function(ev) { if (ev.target === overlay) closeIt(); };
                    }

                    function showPolicyModal(title, text) {
                        var old = document.getElementById("policy-modal-overlay");
                        if (old) old.remove();

                        var overlay = document.createElement("div");
                        overlay.id = "policy-modal-overlay";
                        overlay.setAttribute("style", "position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(15,23,42,0.7);backdrop-filter:blur(8px);opacity:0;transition:opacity 0.25s ease-out;");

                        var card = document.createElement("div");
                        card.setAttribute("style", "background:#fff;border-radius:24px;max-width:600px;width:100%;max-height:80vh;display:flex;flex-direction:column;padding:32px 28px;box-shadow:0 25px 50px -12px rgba(0,0,0,0.3);transform:scale(0.9);transition:transform 0.25s cubic-bezier(0.16,1,0.3,1);border:1px solid #e2e8f0;");

                        var h3 = document.createElement("h3");
                        h3.setAttribute("style", "margin:0 0 16px 0;color:#0f172a;font-size:1.5rem;font-weight:800;border-bottom:1px solid #f1f5f9;padding-bottom:12px;text-align:left;");
                        h3.textContent = title;

                        var bodyDiv = document.createElement("div");
                        bodyDiv.setAttribute("style", "flex:1;overflow-y:auto;margin-bottom:24px;color:#334155;font-size:0.95rem;line-height:1.6;white-space:pre-wrap;text-align:left;padding-right:8px;");
                        bodyDiv.textContent = text;

                        var themeBg = getThemeColor();
                        var btn = document.createElement("button");
                        btn.setAttribute("style", "width:100%;padding:14px 24px;background-color:" + themeBg + ";color:#fff;border:none;border-radius:12px;font-weight:600;font-size:0.95rem;cursor:pointer;transition:all 0.2s ease;box-shadow:0 4px 14px rgba(0,0,0,0.1);");
                        btn.textContent = "Close";

                        function closePolicy() {
                            overlay.style.opacity = "0";
                            card.style.transform = "scale(0.9)";
                            setTimeout(function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 250);
                        }

                        btn.onclick = closePolicy;
                        overlay.onclick = function(ev) { if (ev.target === overlay) closePolicy(); };

                        card.appendChild(h3);
                        card.appendChild(bodyDiv);
                        card.appendChild(btn);
                        overlay.appendChild(card);
                        document.body.appendChild(overlay);

                        requestAnimationFrame(function() {
                            overlay.style.opacity = "1";
                            card.style.transform = "scale(1)";
                        });
                    }

                    document.addEventListener("click", function(ev) {
                        var target = ev.target;
                        if (!target) return;
                        var link = target.closest ? target.closest('a') : null;
                        if (link) {
                            var textContent = (link.textContent || "").trim().toLowerCase();
                            var isPrivacy = textContent.indexOf("privacy") > -1;
                            var isTerms = textContent.indexOf("terms") > -1 || textContent.indexOf("service") > -1 || textContent.indexOf("condition") > -1;
                            
                            if (isPrivacy || isTerms) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                
                                var title = isPrivacy ? "Privacy Policy" : "Terms of Service";
                                var text = isPrivacy 
                                    ? ${JSON.stringify(siteData.privacy_policy || "No Privacy Policy configured yet.")}
                                    : ${JSON.stringify(siteData.terms_conditions || "No Terms of Service configured yet.")};
                                showPolicyModal(title, text);
                            }
                        }
                    });

                    function submitContact(form) {
                        var nameEl = form.querySelector("input[type=text], input[name=name]");
                        var emailEl = form.querySelector("input[type=email], input[name=email]");
                        var msgEl = form.querySelector("textarea, input[name=message]");

                        var n = (nameEl && nameEl.value) ? nameEl.value : "Visitor";
                        var e = (emailEl && emailEl.value) ? emailEl.value : "visitor@example.com";
                        var m = (msgEl && msgEl.value) ? msgEl.value : "General Inquiry";

                        var host = window.location.hostname;
                        var parts = host.split(".");
                        var slug = parts[0];
                        if (slug === "localhost" || slug === "127") slug = "one-1555";
                        
                        // Handle custom domains or specific live sites mapping slug lookup
                        var isCustom = host.indexOf("aaharamcloud.com") === -1 && host.indexOf("localhost") === -1;
                        if (isCustom) {
                            slug = host;
                        }

                        showModal("Message Submitted!", "Thank you! Your message has been sent to the website owner.");
                        form.reset();

                        var api = (window.location.hostname.indexOf("localhost") > -1 ? "http://localhost:5001" : "") + "/api/sites/public/contact";

                        fetch(api, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ slug: slug, name: n, email: e, message: m })
                        }).then(function(r) { return r.json(); })
                        .then(function(d) { console.log("[Contact OK]", d); })
                        .catch(function(err) { console.error("[Contact ERR]", err); });
                    }

                    // Hamburger nav close
                    document.addEventListener("click", function(ev) {
                        if (ev.target && ev.target.closest && ev.target.closest(".nav-links a, nav a, header a")) {
                            var toggles = document.querySelectorAll("input[type=checkbox]");
                            for (var i = 0; i < toggles.length; i++) toggles[i].checked = false;
                        }
                    });

                    // Intercept all form submits
                    document.addEventListener("submit", function(ev) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        var form = ev.target;
                        if (form && form.tagName === "FORM") {
                            submitContact(form);
                        }
                        return false;
                    }, true);

                    // Also intercept submit button clicks directly
                    document.addEventListener("click", function(ev) {
                        var t = ev.target;
                        if (!t) return;
                        var btn = t.closest ? t.closest("button[type=submit], input[type=submit]") : null;
                        if (!btn) btn = (t.tagName === "BUTTON" && t.closest("form")) ? t : null;
                        if (btn) {
                            var form = btn.closest("form");
                            if (form) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                submitContact(form);
                            }
                        }
                    }, true);
                })();
            </script>
        </body>
        </html>
    `);
    document.close();
};

export const TenantProvider = ({ children }) => {
    const location = useLocation();
    const [tenant, setTenant] = useState(null);
    const [franchise, setFranchise] = useState(null);
    const [branches, setBranches] = useState([]);
    const [isFranchise, setIsFranchise] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [customUrl, setCustomUrl] = useState('');

    const [isPortal, setIsPortal] = useState(false);

    const fetchTenant = async () => {
        let slug = '';
        try {
            const hostname = window.location.hostname;
            const parts = hostname.split('.');
            const urlParams = new URLSearchParams(window.location.search);
            const querySlug = urlParams.get('restaurant') || urlParams.get('tenant');
            
            const pathname = window.location.pathname;
            const branchMatch = pathname.match(/^\/branch\/([^/]+)/);

            const portalDomains = [
                'localhost',
                '127.0.0.1',
                'savorybites.vercel.app',
                'aaharamcloud.vercel.app',
                'aaharamcloud.com',
                'www.aaharamcloud.com'
            ];

            // 1. Check if this is a custom domain (not portal, not localhost, and not a subdomain of aaharamcloud.com)
            const isCustomDomain = !portalDomains.includes(hostname) && !hostname.endsWith('.aaharamcloud.com') && !hostname.endsWith('.localhost');
            
            if (isCustomDomain) {
                try {
                    const siteRes = await api.get(`/api/sites/public/slug/${hostname}`);
                    const siteData = siteRes.data;
                    if (siteData && siteData.html_content) {
                        renderStaticSite(siteData);
                        return;
                    }
                } catch (e) {
                    console.error('Custom domain site fetch failed', e);
                }
            }

            slug = '';
            if (branchMatch) {
                slug = branchMatch[1];
                localStorage.setItem('active_branch_slug', slug);
                localStorage.setItem('tenant_slug', slug);
                setIsPortal(false);
            } else if (querySlug) {
                slug = querySlug;
                localStorage.setItem('tenant_slug', slug);
                setIsPortal(false);
            } else if (portalDomains.includes(hostname) || parts.length === 1) {
                const cachedSlug = localStorage.getItem('tenant_slug');
                
                if (pathname === '/' && !querySlug) {
                    localStorage.removeItem('tenant_slug');
                    localStorage.removeItem('active_branch_slug');
                    setIsPortal(true);
                    setLoading(false);
                    return;
                } else if (cachedSlug) {
                    slug = cachedSlug;
                    setIsPortal(false);
                } else {
                    setIsPortal(true);
                    setLoading(false);
                    return;
                }
            } else {
                slug = parts[0];
                localStorage.setItem('tenant_slug', slug);
                setIsPortal(false);
            }

            if (slug) {
                const response = await api.get(`/api/restaurants/slug/${slug}`);
                const isSystemRoute = pathname.startsWith('/admin') || 
                                      pathname.startsWith('/kitchen') || 
                                      pathname.startsWith('/delivery') || 
                                      pathname.startsWith('/unauthorized') || 
                                      pathname.startsWith('/login') || 
                                      pathname.startsWith('/register') || 
                                      pathname.startsWith('/verify-otp') || 
                                      pathname.startsWith('/forgot-password') || 
                                      pathname.startsWith('/reset-password') || 
                                      pathname.startsWith('/super-admin') ||
                                      pathname.startsWith('/franchise-onboard') ||
                                      pathname.startsWith('/set-password') ||
                                      new URLSearchParams(window.location.search).has('token');

                if (response.data.isFranchise) {
                    setIsFranchise(true);
                    setFranchise(response.data.franchise);
                    setBranches(response.data.branches);
                    
                    const color = response.data.franchise.primary_color;
                    const secColor = response.data.franchise.secondary_color;
                    if (color) {
                        document.documentElement.style.setProperty('--primary-600', color);
                        document.documentElement.style.setProperty('--primary-500', color);
                        document.documentElement.style.setProperty('--primary-700', color);
                    }
                    if (secColor) {
                        document.documentElement.style.setProperty('--secondary-600', secColor);
                        document.documentElement.style.setProperty('--secondary-500', secColor);
                        document.documentElement.style.setProperty('--secondary-700', secColor);
                    }

                    try {
                        const rawHs = response.data.franchise.home_settings;
                        const hs = typeof rawHs === 'string' ? JSON.parse(rawHs) : rawHs || {};
                        const btnText = hs.primaryButtonTextColor || '#ffffff';
                        const activeText = hs.sidebarActiveTextColor || color || '#5b4310';
                        const activeBg = hs.sidebarActiveBgColor || (color ? color + '1a' : 'rgba(91, 67, 16, 0.1)');
                        const enableStroke = hs.enableTextStroke === 'yes';
                        
                        document.documentElement.style.setProperty('--primary-btn-text', btnText);
                        document.documentElement.style.setProperty('--sidebar-active-text', activeText);
                        document.documentElement.style.setProperty('--sidebar-active-bg', activeBg);
                        document.documentElement.style.setProperty('--text-stroke-navbar', enableStroke ? '1px rgba(0, 0, 0, 0.4)' : 'none');
                        document.documentElement.style.setProperty('--text-stroke-hero', enableStroke ? '1px rgba(0, 0, 0, 0.9)' : 'none');
                    } catch (e) {
                        console.error('Failed to apply home settings', e);
                    }
                } else {
                    setIsFranchise(false);
                    setTenant(response.data);
                    setTenantId(response.data.id);
                    
                    const color = response.data.primary_color;
                    const secColor = response.data.secondary_color;
                    if (color) {
                        document.documentElement.style.setProperty('--primary-600', color);
                        document.documentElement.style.setProperty('--primary-500', color);
                        document.documentElement.style.setProperty('--primary-700', color);
                    }
                    if (secColor) {
                        document.documentElement.style.setProperty('--secondary-600', secColor);
                        document.documentElement.style.setProperty('--secondary-500', secColor);
                        document.documentElement.style.setProperty('--secondary-700', secColor);
                    }
                }

                if (response.data.website_type === 'custom' && response.data.custom_frontend_url && !isSystemRoute) {
                    setCustomUrl(response.data.custom_frontend_url);
                    setLoading(false);
                    return;
                }
                window.__tenantInfo = response.data;
                setTenant(response.data);
                setTenantId(response.data.id);
            }
        } catch (err) {
            console.error('Failed to load tenant:', err);
            
            // Try fallback: Check if this subdomain is a published website builder static site!
            try {
                const siteRes = await api.get(`/api/sites/public/slug/${slug}`);
                const siteData = siteRes.data;
                
                if (siteData && siteData.html_content) {
                    renderStaticSite(siteData);
                    return;
                }
            } catch (fallbackErr) {
                console.error('[Fallback Website Route Error]:', fallbackErr.response?.status, fallbackErr.response?.data || fallbackErr.message);
                console.log('Subdomain slug is not a published website builder site either. Displaying standard 404.');
            }

            setError('Restaurant not found or inactive.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTenant();
    }, [location.pathname, location.search]);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'REDIRECT') {
                window.location.href = event.data.url;
            } else if (event.data && event.data.type === 'PLATFORM_LOGOUT') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.reload();
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    // Dynamic Multi-Tenant Chatbot Script Loader
    useEffect(() => {
        if (!tenant || !tenant.chatbot_config) return;

        const { provider, widgetId } = tenant.chatbot_config;
        if (!widgetId) return;

        const script = document.createElement('script');
        script.async = true;

        if (provider === 'tidio') {
            script.src = `//code.tidio.co/${widgetId}.js`;
        } else if (provider === 'tawkto') {
            const path = widgetId.includes('/') ? widgetId : `${widgetId}/default`;
            script.src = `https://embed.tawk.to/${path}`;
            script.charset = 'UTF-8';
            script.setAttribute('crossorigin', '*');
        }

        document.body.appendChild(script);

        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            const tidioWidget = document.getElementById('tidio-chat');
            if (tidioWidget) tidioWidget.remove();
            
            const tawkWidget = document.querySelector('iframe[title="widget-button"]');
            if (tawkWidget) tawkWidget.remove();
            const tawkContainer = document.getElementById('tawkchat-container');
            if (tawkContainer) tawkContainer.remove();
        };
    }, [tenant]);

    const refreshTenant = () => {
        fetchTenant();
    };

    if (loading) {
        return <Loading mode="full" message="Connecting to cloud..." />;
    }

    const pathname = window.location.pathname;
    const isStaffOrAdminPath = pathname.startsWith('/admin') || 
                               pathname.startsWith('/kitchen') || 
                               pathname.startsWith('/delivery') || 
                               pathname.startsWith('/unauthorized') ||
                               pathname.startsWith('/login');

    if (customUrl && !isStaffOrAdminPath) {
        const token = localStorage.getItem('token');
        const iframeSrc = token 
            ? `${customUrl}${customUrl.includes('?') ? '&' : '?'}platform_token=${token}`
            : `${customUrl}${customUrl.includes('?') ? '&' : '?'}platform_token=logout`;

        return (
            <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
                <iframe 
                    src={iframeSrc} 
                    title="Custom Storefront" 
                    allow="geolocation"
                    style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
                />
            </div>
        );
    }

    // Portal view (Landing Page / Platform)
    if (isPortal) {
        return (
            <TenantContext.Provider value={{ tenant: null, isPortal: true, refreshTenant, franchise, branches, isFranchise, setTenant, setTenantId }}>
                {children}
            </TenantContext.Provider>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6 font-sans relative overflow-hidden">
                {/* Background ambient glow circles */}
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-indigo-500/10 rounded-full blur-[120px] pointer-events-none"></div>
                <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-rose-500/10 rounded-full blur-[120px] pointer-events-none"></div>

                <div className="bg-slate-900/60 backdrop-blur-xl rounded-3xl p-8 sm:p-10 max-w-md w-full text-center border border-slate-800 shadow-2xl relative space-y-6">
                    <div className="w-16 h-16 bg-rose-500/10 text-rose-500 rounded-2xl flex items-center justify-center mx-auto border border-rose-500/20">
                        <ShieldAlert className="w-8 h-8" />
                    </div>
                    
                    <div className="space-y-2">
                        <h1 className="text-3xl font-black text-white tracking-tight">Outlet Offline</h1>
                        <p className="text-slate-400 text-sm leading-relaxed">
                            This restaurant storefront is currently inactive, pending activation, or does not exist on our servers.
                        </p>
                    </div>

                    <div className="p-4 bg-slate-950/80 rounded-2xl border border-slate-800/80 text-left space-y-1.5 font-mono text-[11px] text-slate-500">
                        <div className="flex justify-between">
                            <span>Requested Domain:</span>
                            <span className="text-slate-300 font-bold">{window.location.hostname}</span>
                        </div>
                        <div className="flex justify-between">
                            <span>Error Code:</span>
                            <span className="text-amber-400 font-bold">404_NOT_FOUND</span>
                        </div>
                    </div>

                    <div className="pt-2">
                        <a 
                            href="/" 
                            className="w-full py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-black text-xs uppercase tracking-widest rounded-xl flex items-center justify-center gap-2 shadow-xl shadow-indigo-900/30 transition-all"
                        >
                            <Home className="w-4 h-4" />
                            <span>Return to Platform Home</span>
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <TenantContext.Provider value={{ tenant, refreshTenant, franchise, branches, isFranchise, setTenant, setTenantId }}>
            {children}
        </TenantContext.Provider>
    );
};

export const useTenant = () => useContext(TenantContext);
